/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/button-has-type */
import React from "react";

import CurrencyTextField from '@unicef/material-ui-currency-textfield';
import moment from "moment/moment";

import ArrowBackIcon from 'images/icons/arrows/arrowBackWhiteLightBlueBgRounded.svg';
import AlertIcon from 'images/icons/signals/alerts/alertWhiteLightRedBgCircle.svg'
import CheckedIcon from 'images/icons/signals/checks/checkedWhiteLightGreenBgRounded.svg';
import numberToReal from 'utils/numberToReal';
import ValidationLength from 'utils/utils';

function NfceConfirmValues({
  setModalSettings,
  modalSettings,
  setCurrentHeader,
  setCurrentItem,
  confirmationNfceItem,
  setConfirmationNfceItem,
  totalItemsValue,
  totalValueConfirmation,
  setTotalValueConfirmation
}) {
  const isItemValid = (item) => item?.description && 
    item?.unitMeasurement && 
    item?.code &&
    item?.quantity &&
    item?.unitaryValue &&
    item?.totalValue

  const invalidAccessKeyLength = confirmationNfceItem?.accessKey?.length !== 44

  return (
    <section className="nfceConfirmValuesContainer">
      <div className="nfceMainInfos">
        <div className="iconBox">
          <img
            onClick={() => {
              setConfirmationNfceItem('')
            }}
            src={ArrowBackIcon}
            alt="ArrowBackIcon"
          />
        </div>

        <div 
          className="nfceInfos"
          onClick={() => {
            setModalSettings(
              modalSettings.map((modal) =>
                modal.name === 'editHeaderDialog' ? { ...modal, open: true } : modal
              )
            );
            setCurrentHeader(confirmationNfceItem)
          }}
        >
          <div className="firstLineInfos">
            {confirmationNfceItem?.number
            ?
              <span className='bold'>
                NFCe {confirmationNfceItem?.number}
              </span>
            :
              <span className="invalidField">
                NFCe -
              </span>
            }

            {confirmationNfceItem?.date
            ?
              <span className="bold">
                {moment(confirmationNfceItem?.date)?.format("DD/MM/YYYY")}
              </span>
            :
              <span className="invalidField">
                --/--/----
              </span>
            }
          </div>

          <div className="secondLineInfos">
            {confirmationNfceItem?.accessKey
            ?
              <span className={`${invalidAccessKeyLength ? 'invalidField' : ''}`}>
                {invalidAccessKeyLength
                  ? 'Chave de acesso inválida'
                  : ValidationLength(confirmationNfceItem?.accessKey, 35)
                }
              </span>
            :
              <span className="invalidField">
                Chave de acesso inválida
              </span>
            }
          </div>

          <div className="thirdLineInfos">
            {confirmationNfceItem?.provider?.nickname || confirmationNfceItem?.provider?.name
            ?
              <span>
                {ValidationLength(confirmationNfceItem?.provider?.nickname || confirmationNfceItem?.provider?.name, 35)}
              </span>
            :
              <span className="invalidField">
                Não encontrado
              </span>
            }
          </div>
        </div>
      </div>

      <div className="nfceItemsInfos">
        <div className="itemsCountHeader">
          <span>
            {confirmationNfceItem?.items?.length} {confirmationNfceItem?.items?.length === 1 ? 'ITEM' : 'ITENS'}
          </span>

          <span
            onClick={() => {
              setModalSettings(
                modalSettings.map((modal) =>
                  modal.name === 'editItemDialog' ? { ...modal, open: true, isNewItem: true } : modal
                )
              );

              setCurrentItem({
                id: (confirmationNfceItem?.items?.length || 0) + 1
              })
            }}
          >
            +
          </span>
        </div>

        {confirmationNfceItem?.items?.map((item) => {
          const unit = item?.unitMeasurement?.toUpperCase()

          return (
            <div 
              className="defaultItem"
              onClick={() => {
                setModalSettings(
                  modalSettings.map((modal) =>
                    modal.name === 'editItemDialog' ? { ...modal, open: true, isNewItem: false } : modal
                  )
                );

                setCurrentItem(item)
              }}
            >
              <div className="dFlex alignCenter">
                <div className="itemStatus">
                  <img
                    onClick={() => {
                      setConfirmationNfceItem('')
                    }}
                    src={isItemValid(item) ? CheckedIcon : AlertIcon}
                    alt="ArrowBackIcon"
                  />
                </div>
                
                <div className="firstLineInfos w100">
                  {item?.description
                  ?
                    <span>
                      {ValidationLength(item?.description, 25)}
                    </span>
                  :
                    <span className="invalidField">
                      DESCRIÇÃO NÃO IDENTIFICADA
                    </span>
                  }

                  {item?.code
                  ?
                    <span>
                      cód.: {item?.code}
                    </span>
                  :
                    <span className="invalidField">
                      00000000000000
                    </span>
                  }
                </div>
              </div>

              <div className="secondLineInfos">
                <span>
                  qtde: 
                  
                  {item?.quantity
                    ?
                      <b>
                        {numberToReal(item?.quantity)} 
                      </b>
                    :
                      <b className="invalidField">
                        0,000
                      </b>
                  }

                  {unit
                    ?
                      <b>
                        {unit}
                      </b>
                    :
                      <b className="invalidField">
                        UN
                      </b>
                  }
                </span>

                <span>
                  un.:
                  
                  {item?.unitaryValue
                    ?
                      <b>
                        R$ {numberToReal(item?.unitaryValue, 2)} 
                      </b>
                    :
                      <b className="invalidField">
                        R$ 0,00
                      </b>
                  }
                </span>

                {item?.totalValue
                  ?
                    <span className="bold fontSizeDefault">
                      R$ {numberToReal(item?.totalValue, 2)} 
                    </span>
                  :
                    <span className="bold fontSizeDefault invalidField">
                      R$ 0,00
                    </span>
                }
              </div>
            </div>
          )
        })}
      </div>

      <div className="totalInfos">
        <span>
          *Clique nos itens para editá-los
        </span>

        <span>
          TOTAL:

          <b>
            R$ {numberToReal(totalItemsValue, 2)}
          </b>
        </span>
      </div>

      {/* <div className="confirmTotalInfosValue">
        <span>
          CONFIRME O VALOR TOTAL:
        </span>

        <CurrencyTextField
          className="textFieldSmall right"
          margin="none"
          variant="standard"
          size="small"
          currencySymbol=""
          minimumValue="0"
          maximumValue="999999999"
          outputFormat="string"
          decimalCharacter=","
          digitGroupSeparator="."
          decimalPlaces={2}
          type="text"
          name="quantity"
          fullWidth
          defaultValue={totalValueConfirmation}
          onChange={(e) => {
            setTotalValueConfirmation(parseFloat(e.target.value?.replace(".", "").replace(",", ".")));
          }}
        />
      </div> */}
      
      {/* {totalItemsValue !== totalValueConfirmation ?
        <span className="error">
          Valor total da nota divergente, por favor verifique os valores.
        </span>
      : null} */}
    </section>
  );
}

export default NfceConfirmValues;